export type CourseListViewMode = keyof typeof CoursesListViewConsts.viewMode;

export namespace CoursesListViewConsts {
  export const viewMode = {
    advanced: 'advanced',
    simple: 'simple'
  } as const;

  export const defaultViewMode = viewMode.advanced;
}
